import { memo as Memo, useCallback, useEffect } from 'react';
import { gsap } from 'gsap';

const GameEyes = Memo(() => {
	useEffect(() => {
		window.addEventListener('mousemove', mouseMove);
		return () => {
			window.removeEventListener('mousemove', mouseMove);
		};
	}, []);

	const mouseMove = useCallback((e) => {
		const size = -5;
		const winWPart = window.innerWidth / 2;
		const winHPart = window.innerHeight / 2;
		const x = ((winWPart - e.clientX) / winWPart) * size;
		const y = ((winHPart - e.clientY) / winHPart) * size;

		gsap.killTweensOf('.GameEyes-e');
		gsap.killTweensOf('.GameEyes-m');

		gsap.to('.GameEyes-e', { duration: 0.5, x, y });
		gsap.to('.GameEyes-m', { duration: 0.5, x: x * 0.8, y: y * 0.8 });
	}, []);

	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			className='ziggyEyes svg-max'
			viewBox='0 0 183.61 228.18'>
			<path d='M3.82,169.74c-.81,0-1.66-.12-2.54-.37-.93-.26-1.48-1.22-1.22-2.15.26-.93,1.22-1.48,2.15-1.22,1.1.31,2.06.32,2.84.04,4.31-1.53,4.47-11.65,4.64-22.36.24-15.14.51-32.3,11.31-39.93,2.94-2.07,6.46-3.3,10.48-3.64.96-.09,1.81.63,1.89,1.6.08.96-.63,1.81-1.6,1.89-3.39.29-6.34,1.3-8.76,3.01-9.35,6.6-9.61,22.82-9.83,37.12-.2,12.48-.37,23.26-6.96,25.6-.76.27-1.56.4-2.41.4Z' />
			<path d='M178.68,173.17c-.85,0-1.66-.13-2.41-.4-6.6-2.34-6.77-13.12-6.96-25.6-.22-14.31-.48-30.52-9.83-37.12-2.42-1.71-5.37-2.72-8.76-3.01-.96-.08-1.68-.93-1.6-1.89s.93-1.68,1.89-1.6c4.02.34,7.55,1.56,10.48,3.64,10.8,7.63,11.07,24.79,11.31,39.93.17,10.71.33,20.83,4.64,22.36.79.28,1.75.27,2.84-.04.93-.26,1.9.29,2.15,1.22.26.93-.29,1.9-1.22,2.15-.88.24-1.73.37-2.54.37Z' />
			<path d='M124.68,228.18c-.16,0-.33-.02-.5-.07l-3.93-1.17c-4.3-1.28-7.33-4.99-7.7-9.47-.33-3.95-.73-12.47-1.08-19.98-.28-6.11-.55-11.88-.72-13.73-.09-.96.62-1.81,1.58-1.9.96-.09,1.81.62,1.9,1.58.17,1.93.43,7.47.73,13.89.35,7.49.74,15.97,1.07,19.86.25,3.02,2.3,5.54,5.21,6.4l3.93,1.17c.93.28,1.45,1.25,1.18,2.18-.23.76-.92,1.25-1.68,1.25Z' />
			<path d='M64.59,228.18c-.75,0-1.45-.49-1.68-1.25-.27-.93.25-1.9,1.18-2.18l3.93-1.17c2.91-.86,4.96-3.38,5.21-6.4.32-3.89.72-12.38,1.07-19.88.3-6.41.56-11.94.73-13.86.09-.96.94-1.67,1.9-1.59.96.09,1.67.94,1.59,1.9-.17,1.85-.44,7.61-.72,13.71-.35,7.53-.75,16.06-1.08,20.01-.37,4.47-3.4,8.19-7.7,9.47l-3.93,1.17c-.17.05-.33.07-.5.07Z' />
			<path d='M31.2,183.6h117.13L183.61,11.13,5.65,0c8.52,61.2,17.03,122.4,25.55,183.6Z' />
			<path
				fill='var(--color1)'
				className='GameEyes-m'
				d='M57.05,76.83l4.05-9.17h3.6l-6,13.33h-3.35l-6-13.33h3.58l4.12,9.17Z'
			/>
			<g>
				<path
					className='GameEyes-e'
					fill='var(--color1)'
					d='M36.8,50.66c.7-1.29,1.67-2.29,2.91-3,1.24-.71,2.66-1.07,4.26-1.07,2.06,0,3.77.52,5.12,1.54,1.35,1.03,2.25,2.48,2.71,4.34h-4.53c-.24-.72-.64-1.29-1.21-1.7-.57-.41-1.27-.62-2.11-.62-1.2,0-2.15.44-2.85,1.3-.7.87-1.05,2.11-1.05,3.71s.35,2.81,1.05,3.68c.7.87,1.65,1.3,2.85,1.3,1.7,0,2.81-.76,3.33-2.28h4.53c-.46,1.8-1.37,3.23-2.73,4.29-1.36,1.06-3.06,1.59-5.1,1.59-1.6,0-3.02-.35-4.26-1.06-1.24-.71-2.21-1.71-2.91-3-.7-1.29-1.05-2.79-1.05-4.52s.35-3.22,1.05-4.51Z'
				/>
				<path
					className='GameEyes-e'
					fill='var(--color1)'
					d='M62,50.66c.7-1.29,1.67-2.29,2.91-3,1.24-.71,2.66-1.07,4.26-1.07,2.06,0,3.77.52,5.12,1.54,1.35,1.03,2.25,2.48,2.71,4.34h-4.53c-.24-.72-.64-1.29-1.21-1.7-.57-.41-1.27-.62-2.11-.62-1.2,0-2.15.44-2.85,1.3-.7.87-1.05,2.11-1.05,3.71s.35,2.81,1.05,3.68c.7.87,1.65,1.3,2.85,1.3,1.7,0,2.81-.76,3.33-2.28h4.53c-.46,1.8-1.37,3.23-2.73,4.29-1.36,1.06-3.06,1.59-5.1,1.59-1.6,0-3.02-.35-4.26-1.06-1.24-.71-2.21-1.71-2.91-3-.7-1.29-1.05-2.79-1.05-4.52s.35-3.22,1.05-4.51Z'
				/>
			</g>
		</svg>
	);
});

export default GameEyes;
